{
    "name": "app",
    "version": "1.0.11",
    "scripts": {
        "ng": "ng",
        "start": "ng serve --port 4300",
        "build": "ng build",
        "buildForTeamcity": "ng build --configuration %ENVIRONMENT%",
        "watch": "ng build --watch --configuration development",
        "test": "ng test",
        "lint": "ng lint",
        "i18n:extract:all": "npm run i18n:extract && npm run i18n:extract:tools && npm run i18n:extract:document && npm run i18n:extract:avatar",
        "i18n:extract": "ngx-translate-extract -i ./src/app -o ./src/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:tools": "ngx-translate-extract -i ./src/sb-tools -o ./src/sb-tools/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:document": "ngx-translate-extract -i ./src/sb-modules/Frontend-Document-Viewer-Module -o ./src/sb-modules/Frontend-Document-Viewer-Module/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:avatar": "ngx-translate-extract -i ./src/sb-modules/Frontend-User-Avatar-Module -o ./src/sb-modules/Frontend-User-Avatar-Module/assets/i18n/en.json --sort -f json --clean",
        "prepare": "husky install",
        "prettier": "npx prettier --write ."
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "^20.3.1",
        "@angular/common": "^20.3.1",
        "@angular/compiler": "^20.3.1",
        "@angular/core": "^20.3.1",
        "@angular/forms": "^20.3.1",
        "@angular/platform-browser": "^20.3.1",
        "@angular/platform-browser-dynamic": "^20.3.1",
        "@angular/router": "^20.3.1",
        "@ctrl/ngx-emoji-mart": "^9.3.0",
        "@microsoft/applicationinsights-web": "^2.8.8",
        "@microsoft/signalr": "^7.0.7",
        "@ngx-translate/core": "^15.0.0",
        "@types/signalr": "^2.4.0",
        "angular2-notifications": "^16.0.1",
        "autolinker": "^4.0.0",
        "intl-tel-input": "^25.10.6",
        "jquery": "^3.7.1",
        "ngx-avatars": "^1.10.0",
        "ngx-bootstrap": "^19.0.0",
        "ngx-doc-viewer": "^15.0.1",
        "ngx-dropzone-wrapper": "^17.0.0",
        "ngx-linky": "^4.0.0",
        "ngx-quill": "^28.0.1",
        "ngx-translate-multi-http-loader": "^18.0.0",
        "quill": "^2.0.2",
        "quill-image-resize": "^3.0.9",
        "rxjs": "^7.8.1",
        "tslib": "^2.7.0",
        "vanilla-js-wheel-zoom": "^9.0.2",
        "zone.js": "^0.15.0"
    },
    "devDependencies": {
        "@angular-eslint/builder": "20.7.0",
        "@angular/build": "^20.3.2",
        "@angular/cli": "~20.3.2",
        "@angular/compiler-cli": "^20.3.1",
        "@eslint/js": "^9.39.1",
        "@types/jasmine": "^5.1.4",
        "@types/jquery": "^3.5.14",
        "@vendure/ngx-translate-extract": "^9.4.0",
        "angular-eslint": "20.7.0",
        "deepmerge-ts": "^7.1.0",
        "eslint": "^9.39.1",
        "eslint-config-prettier": "^10.1.8",
        "eslint-plugin-import": "^2.32.0",
        "eslint-plugin-jsdoc": "^62.4.1",
        "eslint-plugin-prettier": "^5.5.5",
        "husky": "^9.1.5",
        "jasmine-core": "^5.2.0",
        "karma": "^6.4.4",
        "karma-chrome-launcher": "^3.2.0",
        "karma-coverage": "^2.2.1",
        "karma-jasmine": "^5.1.0",
        "karma-jasmine-html-reporter": "^2.1.0",
        "prettier": "^3.3.3",
        "typescript": "~5.8.3",
        "typescript-eslint": "8.46.4"
    }
}
